import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  div__root: {
    marginBottom: '16px',
  },
  typography: {
    width: '90%',
    paddingLeft: '30px',
  },
  acordionText: {
    whiteSpace: 'pre-line',
  },
});
